export enum VehicleInformationType {
  CHECKLIGHT_SESSION = 'CHECKLIGHT_SESSION',
  DEAL = 'DEAL',
  EMBEDDED_INSURANCE = 'EMBEDDED_INSURANCE',
  EMBEDDED_INSURANCE_VERIFICATION = 'EMBEDDED_INSURANCE_VERIFICATION',
  LOAN_ID = 'LOAN_ID',
  LOOKUP_ADDRESS_VIN = 'LOOKUP_ADDRESS_VIN',
  LOOKUP_CHROME_ID = 'LOOKUP_CHROME_ID',
  LOOKUP_PLATE_PROVINCE_VIN = 'LOOKUP_PLATE_PROVINCE_VIN',
  LOOKUP_VIN = 'LOOKUP_VIN',
  LOOKUP_YMMT = 'LOOKUP_YMMT',
  PRODUCT_DATA = 'PRODUCT_DATA',
  RATES_REQUESTED_METADATA = 'RATES_REQUESTED_METADATA',
  REFERENCE = 'REFERENCE',
  REGISTER_RAW_PAYLOAD = 'REGISTER_RAW_PAYLOAD',
  VEHICLE_IMAGES_INFO = 'VEHICLE_IMAGES_INFO',
  VEHICLE_MILEAGE_COMPUTED = 'VEHICLE_MILEAGE_COMPUTED',
  VEHICLE_NORMALIZATION_RESULT = 'VEHICLE_NORMALIZATION_RESULT',
  VEHICLE_VALUE = 'VEHICLE_VALUE',
}
